<template>
  <!-- 選択された情報をまとめて表示するコンポーネント -->
  <div
    class="block-selected-data"
    :class="{
      'is-public-stay': isPublicStay,
      'is-desktop': deviceType === 'pc'
    }"
  >
    <div
      class="block-selected-data__wrap --state"
      :class="{ 'is-public-stay': isPublicStay }"
    >
      <!-- エリア -->
      <div class="block-selected-data__row --area">
        <div class="block-selected-data__icon --map">
          <img
            src="@/assets/icon/icon_map_black.svg"
            alt=""
          >
        </div>
        <div
          class="block-selected-data__text"
          :class="`--${deviceType}`"
        >{{ destinationLabel || '指定なし' }}</div>
      </div>

      <!-- キーワード -->
      <div class="block-selected-data__row --keyword">
        <div class="block-selected-data__icon --search">
          <img
            src="@/assets/icon/icon_search_black.svg"
            alt=""
          >
        </div>
        <div
          class="block-selected-data__text"
          :class="`--${deviceType}`"
        >{{ keywordLabel || '指定なし' }}</div>
      </div>

      <!-- 期間と泊数（国内宿泊施設のみ） -->
      <div
        v-if="!isPublicStay"
        class="block-selected-data__row --stay-period"
      >
        <div class="block-selected-data__icon --calendar">
          <img
            src="@/assets/icon/icon_calendar_black.svg"
            alt=""
          >
        </div>
        <div
          class="block-selected-data__text"
          :class="`--${deviceType}`"
        >{{ stayPeriodLabel }}&emsp;{{ stayNightsLabel }}</div>
      </div>

      <!-- 人数と部屋数（国内宿泊施設のみ） -->
      <div
        v-if="!isPublicStay"
        class="block-selected-data__row --rooms-people"
      >
        <div class="block-selected-data__column --rooms">
          <div class="block-selected-data__icon --bed">
            <img
              src="@/assets/icon/icon_bed_black.svg"
              alt=""
            >
          </div>
          <div
            class="block-selected-data__text"
            :class="`--${deviceType}`"
          >{{ roomsLabel }}</div>
        </div>

        <div class="block-selected-data__column --people">
          <div class="block-selected-data__icon --human">
            <img
              src="@/assets/icon/icon_human_black.svg"
              alt=""
            >
          </div>
          <div
            class="block-selected-data__text"
            :class="`--${deviceType}`"
          >{{ peoplesLabel }}</div>
        </div>
      </div>

      <!-- 料金（国内宿泊施設のみ） -->
      <div
        v-if="!isPublicStay"
        class="block-selected-data__row --price"
      >
        <div class="block-selected-data__icon --yen">
          <img
            src="@/assets/icon/icon_yen_black.svg"
            alt=""
          >
        </div>
        <div
          class="block-selected-data__text"
          :class="`--${deviceType}`"
        >{{ priceLabel }}</div>
      </div>
    </div>

    <!-- こだわり条件（国内宿泊施設のみ） -->
    <div 
      v-if="!isPublicStay"
      class="block-selected-data__wrap --special"
    >
      <div class="block-selected-data__label">こだわり条件</div>
      <div
        class="block-selected-data__text --special"
        :class="`--${deviceType}`"
      >{{ specialConditionsLabel || '指定なし' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPublicStay: {
      type: Boolean,
      required: false,
      default: false
    }, // 公共の宿か
    deviceType: {
      type: String,
      required: false,
      default: 'pc',
      validator: (value) => {
        return ['pc', 'sp'].includes(value)
      }
    }, // デバイス
    destinationLabel: {
      type: String,
      required: false,
      default: ''
    }, // エリア
    keywordLabel: {
      type: String,
      required: false,
      default: ''
    }, // キーワード
    stayPeriodLabel: {
      type: String,
      required: false,
      default: ''
    }, // 宿泊期間
    stayNightsLabel: {
      type: String,
      required: false,
      default: ''
    }, // 泊数
    peoplesLabel: {
      type: String,
      required: false,
      default: ''
    }, // 人数
    roomsLabel: {
      type: String,
      required: false,
      default: ''
    }, // 部屋数
    priceLabel: {
      type: String,
      required: false,
      default: ''
    }, // 料金
    specialConditionsLabel: {
      type: String,
      required: false,
      default: ''
    }, // こだわり条件
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.block-selected-data {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  column-gap: 2rem;

  &.is-desktop {
    background-color: $cool-gray-6;
    border-radius: .25rem;
    padding: 1.5rem;
  }

  &.is-public-stay {
    @include sp {
      padding: 1rem;
    }
  }

  @include sp {
    padding: 1rem;
  }

  &__wrap {
    &.--state,
    &.--special {
      width: calc(50% - 1rem);
    }

    @include sp {
      &.--state { width: 100%; }
      &.--special { display: none; }
    }

    &.is-public-stay {
      &.--state { width: 100%; }
      &.--special { display: none; }
    }
  }

  &__row {
    align-items: center;
    display: flex;
    width: 100%;

    &:not(:last-child) {
      margin-bottom: .5rem;
    }

    @include sp {
      width: 100%;
    }

    &.--full {
      width: 100%;
    }

    &.--special {
      @include sp {
        display: none;
      }
    }

    &.--rooms,
    &.--peoples {
      @include sp {
        display: none;
      }
    }

    &.--rooms-people {

      @include sp {
        display: flex;
      }
    }
  }

  &__column {
    align-items: center;
    display: flex;
  
    &.--rooms {
      width: 5rem;
    }

    &.--people {
      width: calc(100% - 5rem);
    }
  }

  &__label {
    font-size: .875rem;
    font-weight: bold;
    margin-bottom: .5rem;
  }

  &__icon {
    align-items: center;
    display: flex;
    height: 18px;
    justify-content: center;
    width: 18px;

    img {
      display: block;
      height: auto;
      width: 100%;
    }

    &.--search,
    &.--calendar,
    &.--bed,
    &.--yen {
      img {
        width: 1rem;
      }
    }
    
    &.--human {
      img {
        width: .875rem;
      }
    }
  }

  &__text {
    align-items: center;
    display: flex;
    font-size: .875rem;
    line-height: 1.2;
    padding-left: .5rem;
    width: calc(100% - 18px);
    word-break: break-all;

    &.--special {
      font-size: .75rem;
      line-height: 1.4;
      padding-left: 0;
    }
  }
}
</style>